import styled from 'styled-components';

export const CustomTemplatesTabHeaderButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 15px;

  .search-field {
    margin-bottom: 0;
    width: 200px;
  }
`;
